class HeroSlider extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.cr-hero-slider__slide')];
    this.dots = [...this.querySelectorAll('.cr-hero-slider__dot')];
    this.prevButton = this.querySelector('.cr-hero-slider__arrow--prev');
    this.nextButton = this.querySelector('.cr-hero-slider__arrow--next');
    this.current = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;

    if (this.slides.length < 2) return;

    this.prevButton?.addEventListener('click', () => this.go(this.current - 1));
    this.nextButton?.addEventListener('click', () => this.go(this.current + 1));
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.go(index));
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  go(index) {
    const total = this.slides.length;
    this.current = (index + total) % total;
    this.slides.forEach((slide, i) => {
      const active = i === this.current;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    this.dots.forEach((dot, i) => {
      const active = i === this.current;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', String(active));
    });
  }

  start() {
    if (!this.autoplay || this.slides.length < 2) return;
    this.stop();
    this.timer = setInterval(() => this.go(this.current + 1), this.autoplaySpeed);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

customElements.define('hero-slider', HeroSlider);
